function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.2835 0 0 .2835 -5.1944 14.921)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "97.858 95.719 109.3 24.995 127.58 24.995 116.14 95.719",
    style: {
      fill: "#00579f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.44 26.724c-3.607-1.431-9.328-3.011-16.402-3.011-18.059 0-30.776 9.63-30.854 23.398-0.15 10.158 9.105 15.8 16.027 19.187 7.075 3.461 9.48 5.72 9.48 8.805-0.072 4.738-5.717 6.922-10.982 6.922-7.301 0-11.213-1.126-17.158-3.762l-2.408-1.13-2.559 15.876c4.289 1.954 12.191 3.688 20.395 3.764 19.188 0 31.68-9.481 31.828-24.153 0.073-8.051-4.814-14.22-15.35-19.261-6.396-3.236-10.313-5.418-10.313-8.729 0.075-3.01 3.313-6.093 10.533-6.093 5.945-0.151 10.313 1.278 13.622 2.708l1.654 0.751z",
    style: {
      fill: "#00579f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.74 70.664c1.506-4.063 7.301-19.788 7.301-19.788-0.076 0.151 1.503-4.138 2.406-6.771l1.278 6.094s3.463 16.929 4.215 20.465h-15.2zm22.573-45.669h-14.145c-4.362 0-7.676 1.278-9.558 5.868l-27.163 64.855h19.188s3.159-8.729 3.838-10.609h23.479c0.525 2.483 2.182 10.609 2.182 10.609h16.932z",
    style: {
      fill: "#00579f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.584 24.995-17.909 48.227-1.957-9.781c-3.311-11.286-13.695-23.548-25.283-29.645l16.404 61.848h19.338l28.744-70.649z",
    style: {
      fill: "#00579f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.045 24.995h-29.422l-0.301 1.429c22.951 5.869 38.151 20.016 44.396 37.02l-6.396-32.504c-1.053-4.517-4.289-5.796-8.277-5.945z",
    style: {
      fill: "#faa61a"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.84d21cbb.svg";
export { ForwardRef as ReactComponent };